<template>
  <div>
    <v-tabs-items>
      <v-container fluid>
        <v-card-title>Создать пост-отделение</v-card-title>
        <v-card>
          <v-card-text>
            <v-text-field v-model="postIndexForm.postCode"
                          :error-messages="postCodeError"
                          label="Код пост-отделения"/>

            <v-text-field v-model="postIndexForm.name"
                          label="Имя пост-отделения"
                          :error-messages="nameError"
                          :counter="200"
            />

            <v-select v-model="postIndexForm.postRegion"
                      :items="$store.getters.appLogin.regions"
                      :item-text="item => item.name"
                      :item-value="item => item"
                      label="Область"
                      :error-messages="postRegionError"
            />

            <v-select v-model="postIndexForm.postArea"
                      :disabled="!postIndexForm.postRegion"
                      :items="getAres()"
                      :item-text="item => item.name"
                      :item-value="item => item"
                      label="Район"
                      :error-messages="postAreaError"
            />

            <v-checkbox v-model="postIndexForm.isActive"
                        color="primary"
                        :label="`Активный`">
            </v-checkbox>

          </v-card-text>
        </v-card>
      </v-container>
    </v-tabs-items>

    <v-divider/>

    <v-card flat>
      <v-card-actions>
        <v-btn @click="onCancelClicked" color="secondary" text>Отмена</v-btn>
        <v-spacer/>
        <v-btn color="primary" @click="onCreatePostIndexClicked">Добавить</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {maxLength, required} from "vuelidate/lib/validators";
import PostIndexService from "@/services/post.index.service"
import {APP_POSTINDEX_CREATED} from "@/store/modules/app/actions";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import $store from "@/store";

export default {
  name: "CreatePostIndex",
  data() {
    return {
      postIndexForm: {
        postCode: "",
        name: "",
        postRegion: null,
        postArea: null,
        isActive: false
      },

    }
  },
  validations: {
    postIndexForm: {
      postCode: {
        required
      },
      name: {
        required,
        maxLength: maxLength(200)
      },
      postRegion: {
        required
      },
      postArea: {
        required
      }
    }
  },
  computed: {
    nameError() {
      const errors = []

      if (this.$v.postIndexForm.name.$dirty) {
        if (!this.$v.postIndexForm.name.required) {
          errors.push("Введите имя")
        } else {
          !this.$v.postIndexForm.name.maxLength && errors.push(`Слишком длинное`)
        }
      }
      return errors
    },
    postCodeError() {
      const errors = []

      if (this.$v.postIndexForm.postCode.$dirty) {
        if (!this.$v.postIndexForm.postCode.required) {
          errors.push("Введите почтовый код")
        }
      }
      return errors
    },
    postRegionError() {
      const errors = []

      if (this.$v.postIndexForm.postRegion.$dirty) {
        if (!this.$v.postIndexForm.postRegion.required) {
          errors.push("Введите Область")
        }
      }
      return errors
    },
    postAreaError() {
      const errors = []

      if (this.$v.postIndexForm.postArea.$dirty) {
        if (!this.$v.postIndexForm.postArea.required) {
          if (!this.postIndexForm.postArea)
            errors.push("Введите Район")
        }
      }
      return errors
    }
  },
  methods: {
    clear() {
      this.postIndexForm.postCode = ""
      this.postIndexForm.name = ""
      this.postIndexForm.region = ""
      this.postIndexForm.area = ""
      this.postIndexForm.isActive = false

      this.$v.postIndexForm.$reset()
    },

    getAres() {
      var selectedRegion = this.postIndexForm.postRegion?.id;
      if (selectedRegion > 0) {
        return $store.getters.appLogin.areas.filter(item => item.region?.id === selectedRegion)
      } else {
        return $store.getters.appLogin.areas;
      }
    },

    onCreatePostIndexClicked() {
      this.$v.postIndexForm.$touch()

      if (!this.$v.postIndexForm.$invalid) {
        this.$store.dispatch(LAYOUT_LOADING_START)
        PostIndexService.createPostIndex({
          PostCode: this.postIndexForm.postCode,
          Name: this.postIndexForm.name,
          RegionId: this.postIndexForm.postRegion.id,
          AreaId: this.postIndexForm.postArea.id,
          IsActive: this.postIndexForm.isActive
        })
            .then(() => {
              this.$store.dispatch(APP_POSTINDEX_CREATED)
            }, () => {
              this.$store.dispatch(APP_POSTINDEX_CREATED)
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    onCancelClicked() {
      this.clear()
      this.$emit("cancel")
    }
  },
  created() {
    this.clear()
  }
}
</script>

<style scoped>

</style>
